// Translation files for TeamConnect
export const translations = {
  hr: {
    // Common
    common: {
      loading: 'Učitavanje...',
      save: 'Spremi',
      cancel: 'Odustani',
      delete: 'Obriši',
      edit: 'Uredi',
      search: 'Pretraži',
      filter: 'Filtriraj',
      reset: 'Resetiraj',
      back: 'Natrag',
      next: 'Dalje',
      submit: 'Pošalji',
      close: 'Zatvori',
      yes: 'Da',
      no: 'Ne',
      ok: 'OK',
      error: 'Greška',
      success: 'Uspjeh',
      warning: 'Upozorenje',
      info: 'Info',
      all: 'Sve',
      none: 'Ništa',
      select: 'Odaberi',
      required: 'Obavezno',
      optional: 'Opcionalno',
      support: 'Podrška',
      send: 'Pošalji',
      confirm: 'Potvrdi',
      checking: 'Provjera...',
      saving: 'Spremanje...',
      searching: 'Tražim...',
      unknown: 'Nepoznato',
      sortBy: 'Sortiraj po',
    },

    // Navigation
    nav: {
      home: 'Početna',
      dashboard: 'Dashboard',
      teams: 'Timovi',
      myTeams: 'Moji Timovi',
      createTeam: 'Kreiraj Tim',
      tournaments: 'Turniri',
      fields: 'Tereni',
      activities: 'Aktivnosti',
      friends: 'Prijatelji',
      profile: 'Profil',
      settings: 'Postavke',
      logout: 'Odjava',
      login: 'Prijava',
      register: 'Registracija',
      ratings: 'Ocjene',
      statistics: 'Statistika',
      highlights: 'Video isječci',
      admin: 'Admin',
      notifications: 'Notifikacije',
      lightMode: 'Svijetli mod',
      darkMode: 'Tamni mod',
      switchToLight: 'Prebaci na svijetli način',
      switchToDark: 'Prebaci na tamni način',
      messages: 'Poruke',
      groups: 'Grupe',
      myStudio: 'Moj Studio',
    },
    groups: {
  title: 'Grupe',
  subtitle: 'Pridruži se grupi ili kreiraj vlastitu',
  createGroup: 'Kreiraj grupu',
  joinByCode: '🔑 Pridruži se kodom',
  noGroups: 'Nemaš grupa',
  noGroupsDesc: 'Kreiraj novu grupu ili se pridruži postojećoj kodom',
  creator: '👑 Organizator',
  member: '🏃 Član',
  youAreCreator: '👑 Ti si organizator',
  youAreMember: '🏃 Ti si član',
  sessions: 'Treninzi',
  members: 'Članovi',
  newSession: '+ Novi trening',
  inviteCode: '🔑 Invite kod',
  leaveGroup: 'Napusti grupu',
  noSessions: 'Nema treninga',
  noSessionsDesc: 'Kreiraj prvi trening!',
  noMembers: 'Nema članova',
  noMembersDesc: 'Podijeli invite kod da se drugi pridruže',
  inviteCodeTitle: '🔑 Invite kod grupe',
  inviteCodeDesc: 'Podijeli ovaj kod da se drugi pridruže grupi:',
  copyCode: '📋 Kopiraj kod',
  codeCopied: '✅ Kod kopiran!',
  joinGroup: '🔑 Pridruži se grupi',
  inviteCodeLabel: 'Invite kod',
  inviteCodePlaceholder: 'Upiši kod grupe...',
  joinSuccess: '✅ Pridružen/a si grupi!',
  invalidCode: 'Nevažeći kod grupe',
  createGroupTitle: '🏃 Kreiraj Grupu',
  nameLabel: 'Naziv *',
  namePlaceholder: 'npr. OK Jadran Split',
  sportLabel: 'Sport *',
  descLabel: 'Opis',
  minSkill: 'Min. razina (1-10)',
  maxSkill: 'Max. razina (1-10)',
  minPlayers: 'Min. igrača',
  maxPlayers: 'Max. igrača',
  isPublic: '🌍 Učini javnim',
  makePrivate: '🔒 Zatvori javnost',
  publicBadge: '🌍 Javno',
  belowMin: '⚠️ Nedovoljno prijava',
  signedUp: '✅ Prijavljen/a',
  publicSessions: '🌍 Javni treninzi grupa',
  publicSessionsDesc: 'Ovi treninzi su otvoreni za sve — pridruži se!',
  signupSuccess: '✅ Prijavljen/a si na trening!',
  removeCreator: 'Kreator ne može napustiti grupu',
  leaveSuccess: 'Napustio/la si grupu',
  groupCreated: '✅ Grupa kreirana!',
  sessionCreated: '✅ Trening kreiran!',
  memberRemoved: 'Član uklonjen',
  sessionDeleted: 'Trening obrisan',
  visibilityChanged: 'Vidljivost treninga promijenjena',
},
dm: {
  title: 'Poruke',
  noConversations: 'Nema konverzacija',
  selectConversation: 'Odaberi konverzaciju',
},
    // Auth
    auth: {
      login: 'Prijava',
      register: 'Registracija',
      email: 'Email',
      password: 'Lozinka',
      confirmPassword: 'Potvrdi lozinku',
      username: 'Korisničko ime',
      forgotPassword: 'Zaboravljena lozinka?',
      rememberMe: 'Zapamti me',
      noAccount: 'Nemaš račun?',
      hasAccount: 'Već imaš račun?',
      loginSuccess: 'Uspješna prijava!',
      registerSuccess: 'Registracija uspješna! Dobrodošao/la!',
      logoutConfirm: 'Jeste li sigurni da se želite odjaviti?',
      logoutSuccess: 'Uspješna odjava!',
      welcomeBack: 'Dobrodošao/la natrag!',
      createAccount: 'Kreiraj račun',
      yourEmail: 'Tvoj email',
      yourPassword: 'Tvoja lozinka',
      loggingIn: 'Prijavljivanje...',
      loginBtn: 'Prijavi se',
      registerBtn: 'Registriraj se',
      registering: 'Registracija...',
      chooseUsername: 'Odaberi svoje korisničko ime',
      minChars: 'Minimalno {n} znakova',
      welcomeTitle: 'Dobrodošli u TeamConnects!',
      welcomeDesc: 'TeamConnects je aplikacija koja povezuje sportaše i rekreativce po lokaciji i sportu. Pronađi suigrače, pridruži se timovima ili organiziraj vlastite sportske događaje.',
      step1: '1. Registriraj se',
      step2: '2. Odaberi sport',
      step3: '3. Pronađi tim',
      gender: 'Spol',
      selectGender: '-- Odaberi spol --',
      male: 'Muško',
      female: 'Žensko',
      securityQuestion: 'Sigurnosno pitanje',
      selectSecurityQuestion: '-- Odaberi sigurnosno pitanje --',
      securityAnswer: 'Odgovor na sigurnosno pitanje',
      yourAnswer: 'Vaš odgovor...',
      passwordMismatch: 'Lozinke se ne podudaraju!',
      passwordTooShort: 'Lozinka mora imati minimalno 6 znakova!',
      reenterPassword: 'Ponovno upiši lozinku',
      loginError: 'Greška pri prijavi',
      registerError: 'Greška pri registraciji',
      securityQuestions: {
        pet: 'Kako se zove vaš prvi ljubimac?',
        city: 'U kojem ste gradu rođeni?',
        school: 'Kako se zvala vaša osnovna škola?',
        team: 'Koji je vaš omiljeni sportski tim?',
        food: 'Koja je vaša omiljena hrana?',
      },
    },

    // Forgot Password
    forgotPw: {
      title: 'Zaboravljena lozinka',
      enterCode: 'Unesite kod',
      newPassword: 'Nova lozinka',
      securityQuestion: 'Sigurnosno pitanje',
      answerQuestion: 'Odgovorite na pitanje',
      emailDesc: 'Unesite email adresu vašeg računa i poslat ćemo vam kod za resetiranje lozinke.',
      codeDesc: 'Unesite 6-znamenkasti kod koji ste primili na',
      newPasswordDesc: 'Unesite novu lozinku za vaš račun.',
      securityEmailDesc: 'Unesite email adresu vašeg računa da biste dobili sigurnosno pitanje.',
      securityAnswerDesc: 'Odgovorite na sigurnosno pitanje za račun',
      codeSent: 'Kod je poslan na vaš email!',
      codeMustBe6: 'Kod mora imati 6 znamenki!',
      codeValid: 'Kod je ispravan!',
      passwordChanged: 'Lozinka je uspješno promijenjena!',
      answerCorrect: 'Odgovor je ispravan!',
      sendCode: 'Pošalji kod',
      sending: 'Slanje...',
      verifyCode: 'Potvrdi kod',
      verifying: 'Provjera...',
      sendNewCode: 'Pošalji novi kod',
      saveNewPassword: 'Spremi novu lozinku',
      fetchQuestion: 'Dohvati pitanje',
      fetching: 'Traženje...',
      confirmAnswer: 'Potvrdi odgovor',
      useSecurityQuestion: 'Ili koristite sigurnosno pitanje',
      useEmailCode: 'Ili koristite email kod',
      backToLogin: 'Povratak na prijavu',
      needHelp: 'Trebate pomoć? Kontaktirajte nas:',
      userNotFound: 'Korisnik nije pronađen ili nema sigurnosno pitanje',
      invalidCode: 'Neispravan kod',
      sendError: 'Greška pri slanju koda',
      resetError: 'Greška pri promjeni lozinke',
      invalidAnswer: 'Neispravan odgovor',
    },

    // Landing Page
    landing: {
      badge: '🏀 Sportska platforma',
      heroTitle1: 'Pronađi svoj tim.',
      heroTitle2: 'Igraj. Pobijedi.',
      heroDesc: 'TeamConnects povezuje sportaše i rekreativce po lokaciji i sportu. Pronađi suigrače, pridruži se timovima ili organiziraj vlastite sportske događaje.',
      startFree: 'Započni besplatno',
      haveAccount: 'Već imam račun',
      teams: 'Timovi',
      tournaments: 'Turniri',
      fields: 'Tereni',
      featuresTitle: 'Sve što trebaš na jednom mjestu',
      featuresSubtitle: 'TeamConnects ti pomaže pronaći igrače, organizirati utakmice i pratiti svoj napredak.',
      featureFindPlayers: 'Pronađi Suigrače',
      featureFindPlayersDesc: 'Povezuj se s igračima u svom gradu koji dijele tvoju strast za sportom.',
      featureTournaments: 'Turniri',
      featureTournamentsDesc: 'Kreiraj ili se prijavi na turnire. Natječi se i osvoji nagrade!',
      featureFields: 'Sportski Tereni',
      featureFieldsDesc: 'Pronađi savršen teren za svoju utakmicu s detaljnim informacijama.',
      featureStats: 'Statistika',
      featureStatsDesc: 'Prati svoju statistiku, ocjene i napredak kroz vrijeme.',
      featureChat: 'Tim Chat',
      featureChatDesc: 'Komuniciraj s timom u realnom vremenu i organiziraj utakmice.',
      featureVideo: 'Video Isječci',
      featureVideoDesc: 'Dijeli najbolje trenutke sa svojih utakmica.',
      howItWorks: 'Kako funkcionira?',
      step1Title: 'Registriraj se',
      step1Desc: 'Kreiraj besplatan račun u samo par sekundi.',
      step2Title: 'Odaberi sport',
      step2Desc: 'Odaberi svoj omiljeni sport i lokaciju.',
      step3Title: 'Pronađi tim',
      step3Desc: 'Pridruži se postojećem timu ili kreiraj svoj vlastiti!',
      ctaTitle: 'Spreman za igru?',
      ctaDesc: 'Pridruži se TeamConnects zajednici i pronađi svoje suigrače već danas!',
      ctaButton: 'Kreiraj račun besplatno',
      copyright: '© 2026 TeamConnects. Sva prava pridržana.',
      support: 'Podrška',
    },

    // Dashboard
    dashboard: {
      availableTeams: 'Dostupni timovi',
      findTeam: 'Pronađi tim i pridruži se utakmici!',
      createNewTeam: '+ Kreiraj novi tim',
      filterTeams: 'Filtriraj timove',
      allSports: 'Svi sportovi',
      allCountries: 'Sve države',
      allCities: 'Svi gradovi',
      resetFilters: 'Resetiraj filtere',
      noTeams: 'Nema timova',
      noTeamsFiltered: 'Nema timova koji odgovaraju tvojim filterima. Pokušaj promijeniti kriterije.',
      noTeamsEmpty: 'Trenutno nema dostupnih timova. Budi prvi i kreiraj novi tim!',
      loadError: 'Greška pri učitavanju timova',
      joinSuccess: 'Uspješno si se pridružio timu! 🎉',
      joinError: 'Greška pri pridruživanju timu',
      teamIdError: 'Greška: ID tima nije dostupan',
      waitlistError: 'Greška pri dodavanju na listu čekanja',
      popular: 'Popularni',
      other: 'Ostali',
      today: 'Danas',
      tomorrow: 'Sutra',
      saturday: 'Subota',
      sunday: 'Nedjelja',
    },

    // Create Team
    createTeam: {
      title: 'Kreiraj novi tim',
      subtitle: 'Organiziraj utakmicu i pozovi igrače',
      teamNameLabel: 'Naziv tima *',
      teamNamePlaceholder: 'npr. Večernja utakmica na Poljudu',
      sportLabel: 'Sport *',
      selectSport: 'Odaberi sport',
      popularSports: 'Popularni sportovi',
      otherSports: 'Ostali sportovi',
      addNewSport: '+ Dodaj novi sport',
      countryLabel: 'Država *',
      cityLabel: 'Grad *',
      searchCity: 'Pretraži grad...',
      addNewCity: '+ Dodaj novi grad',
      locationLabel: 'Točna lokacija *',
      locationPlaceholder: 'npr. Stadion Poljud, Ulica Vice Vukova 6',
      dateLabel: 'Datum *',
      timeLabel: 'Vrijeme *',
      maxPlayersLabel: 'Maksimalan broj igrača',
      joinAsPlayer: 'Pridruži se kao igrač',
      joinAsPlayerDesc: 'Ako označiš ovu opciju, bit ćeš registriran kao igrač u timu. Inače ćeš biti samo kreator/organizator.',
      yourPosition: 'Tvoja pozicija u timu',
      positionPlaceholder: 'npr. Napadač, Vratar, Centar, Playmaker...',
      positionDesc: 'Upiši poziciju na kojoj želiš igrati (opcionalno)',
      playerFilters: 'Filteri za igrače',
      playerFiltersDesc: 'Postavi uvjete tko se može pridružiti timu',
      genderPreference: 'Spol igrača',
      genderMix: 'Mješovito (svi)',
      genderMaleOnly: 'Samo muškarci',
      genderFemaleOnly: 'Samo žene',
      amateurOnly: 'Samo amateri',
      amateurDesc: 'Igrači s ratingom manjim od 60%',
      minSkill: 'Min. razina vještine',
      maxSkill: 'Max. razina vještine',
      noLimit: 'Bez ograničenja',
      descriptionLabel: 'Opis (opcionalno)',
      descriptionPlaceholder: 'Dodaj dodatne informacije o utakmici...',
      createBtn: 'Kreiraj tim',
      createSuccess: 'Tim uspješno kreiran! 🎉',
      createError: 'Greška pri kreiranju tima',
      fillRequired: 'Popuni sva obavezna polja!',
      addSportTitle: 'Dodaj novi sport',
      addSportDesc: 'Ne vidiš svoj sport na listi? Dodaj ga!',
      sportNameLabel: 'Naziv sporta',
      sportNamePlaceholder: 'npr. Padel, Squash, Paintball...',
      addSportBtn: 'Dodaj sport',
      enterSportName: 'Upiši naziv sporta!',
      sportAdded: 'Sport "{name}" dodan! 🎉',
      addCityTitle: 'Dodaj novi grad',
      addCityDesc: 'Ne vidiš svoj grad na listi? Dodaj ga!',
      cityNameLabel: 'Naziv grada',
      cityNamePlaceholder: 'npr. Mostar, Luxembourg...',
      countryNameLabel: 'Država',
      countryNamePlaceholder: 'npr. Bosna i Hercegovina',
      addCityBtn: 'Dodaj grad',
      fillCityCountry: 'Popuni naziv grada i države!',
      cityAdded: 'Grad "{name}" dodan! 🎉',
      skillLevels: {
        1: '1 - Početnik',
        2: '2 - Srednji',
        3: '3 - Napredni',
        4: '4 - Ekspert',
        5: '5 - Pro',
      },
    },

    // My Teams
    myTeams: {
      title: 'Moji Timovi',
      subtitle: 'Upravljaj svojim timovima',
      createNew: '+ Kreiraj Novi Tim',
      noTeams: 'Nemate timova',
      noTeamsDesc: 'Kreirajte novi tim ili pregledajte postojeće timove na Dashboardu',
      browseTeams: 'Pregledaj Timove',
      loadError: 'Greška pri učitavanju timova',
      leaveConfirm: 'Jeste li sigurni da želite napustiti ovaj tim?',
      leftTeam: 'Napustili ste tim',
      leaveError: 'Greška pri napuštanju tima',
      deleteConfirm: 'Jeste li sigurni da želite obrisati ovaj tim? Ova radnja se ne može poništiti!',
      deleted: 'Tim je obrisan',
      deleteError: 'Greška pri brisanju tima',
    },

    // Teams (existing + new)
    teams: {
      title: 'Timovi',
      availableTeams: 'Dostupni timovi',
      myTeams: 'Moji timovi',
      createTeam: 'Kreiraj tim',
      joinTeam: 'Pridruži se',
      leaveTeam: 'Napusti tim',
      deleteTeam: 'Obriši tim',
      teamName: 'Naziv tima',
      sport: 'Sport',
      location: 'Lokacija',
      date: 'Datum',
      time: 'Vrijeme',
      maxPlayers: 'Maksimalno igrača',
      currentPlayers: 'Trenutno igrača',
      description: 'Opis',
      creator: 'Kreator',
      players: 'Igrači',
      full: 'PUNO',
      waitlist: 'Lista čekanja',
      joinWaitlist: 'Dodaj me na listu čekanja',
      position: 'Pozicija',
      skillLevel: 'Razina vještine',
      amateur: 'Amater',
      createdTeams: 'Timovi koje sam kreirao',
      joinedTeams: 'Timovi kojima sam se pridružio',
      noTeams: 'Nema timova',
      registeredPlayers: 'Prijavljeni igrači',
      showPlayers: 'Prikaži',
      hidePlayers: 'Sakrij',
      noPlayersYet: 'Još nema prijavljenih igrača',
      shareToAttract: 'Podijeli link tima da privučeš igrače!',
      onWaitlist: 'Na listi čekanja',
      skillRange: 'Razina',
      loginToAccess: 'Prijavi se za pristup',
      shareLink: 'Podijeli link',
      linkCopied: 'Kopirano!',
      joinTeamTitle: 'Pridruži se timu',
      joinTeamDesc: 'Unesite poziciju na kojoj želite igrati (opcionalno)',
      positionPlaceholder: 'npr. Napadač, Vratar, Centar...',
      yourRating: 'Tvoja ocjena za',
      ratingError: 'Greška pri spremanju ocjene',
      personsWaiting: '{n} na listi čekanja',
      loginRequired: 'Molimo prijavite se kako biste pristupili ovoj funkciji!',
      alreadyMember: 'Pridruženi ste',
      checking: 'Provjera...',
      chat: 'Chat',
    },

    // Chat
    chat: {
      loadingChat: 'Učitavanje chata...',
      teamNotFound: 'Tim ne postoji',
      playersCount: '{current}/{max} igrača',
      noMessages: 'Nema poruka',
      beFirst: 'Budi prvi koji će nešto napisati!',
      isTyping: '{name} piše...',
      writeMessage: 'Napiši poruku...',
      sendBtn: 'Pošalji',
      shareLocation: 'Podijeli lokaciju',
      locationShared: 'Lokacija poslana!',
      locationNotSupported: 'Geolokacija nije podržana',
      locationError: 'Nije moguće dohvatiti lokaciju',
      viewOnMap: 'Vidi lokaciju na mapi',
      deleteMessage: 'Obriši poruku?',
      today: 'Danas',
      yesterday: 'Jučer',
      back: 'Natrag',
    },

    // Notifications
    notifications: {
      title: 'Notifikacije',
      markAll: 'Označi sve',
      deleteAll: 'Obriši sve',
      filterAll: 'Sve',
      filterUnread: 'Nepročitane',
      noNotifications: 'Nemaš notifikacija',
      noNotificationsDesc: 'Kada se nešto dogodi, vidjet ćeš to ovdje',
      newBadge: 'NOVO',
      allMarkedRead: 'Sve notifikacije označene kao pročitane',
      allDeleted: 'Sve notifikacije obrisane',
      deleteConfirm: 'Jesi li siguran da želiš obrisati sve notifikacije?',
      loadError: 'Greška pri učitavanju notifikacija',
      markError: 'Greška pri označavanju notifikacija',
      deleteError: 'Greška pri brisanju notifikacija',
    },

    // Friends
    friends: {
      title: 'Prijatelji',
      subtitle: 'Povežite se s igračima',
      searchUsers: 'Pretraži korisnike',
      searchPlaceholder: 'Pretraži po korisničkom imenu ili emailu...',
      searchBtn: 'Pretraži',
      searchMinChars: 'Upiši barem 2 znaka!',
      friendsTab: 'Prijatelji',
      requestsTab: 'Zahtjevi',
      resultsTab: 'Rezultati',
      noFriends: 'Nemaš prijatelja',
      noFriendsDesc: 'Pretraži korisnike i dodaj ih u prijatelje!',
      noRequests: 'Nemaš novih zahtjeva',
      noRequestsDesc: 'Kada te netko doda, vidjet ćeš to ovdje',
      noResults: 'Nema rezultata',
      noResultsDesc: 'Pokušaj s drugim pojmom za pretragu',
      viewProfile: 'Vidi profil',
      removeFriend: 'Ukloni',
      removeFriendConfirm: 'Jesi li siguran/a da želiš ukloniti prijatelja?',
      friendRemoved: 'Prijatelj uklonjen',
      removeError: 'Greška pri uklanjanju prijatelja',
      accept: 'Prihvati',
      reject: 'Odbij',
      requestSent: 'Zahtjev poslan!',
      sendError: 'Greška pri slanju zahtjeva',
      acceptError: 'Greška pri prihvaćanju zahtjeva',
      rejectError: 'Greška pri odbijanju zahtjeva',
      rejected: 'Zahtjev odbijen',
      alreadyFriends: 'Već prijatelji',
      requestAlreadySent: 'Zahtjev poslan',
      itsYou: 'To si ti',
      addFriend: '+ Dodaj prijatelja',
      addFriendTitle: 'Dodaj prijatelja',
      sendRequestTo: 'Pošalji zahtjev korisniku',
      messageOptional: 'Poruka (opcionalno)',
      messagePlaceholder: 'Napiši kratku poruku...',
      sendRequest: 'Pošalji zahtjev',
      searchError: 'Greška pri pretrazi',
    },

    // Statistics
    statistics: {
      title: 'Moja Statistika',
      subtitle: 'Prati svoj napredak i performanse',
      selectSport: 'Odaberi sport',
      selectSportDefault: '-- Odaberi sport --',
      addMatch: '+ Dodaj utakmicu',
      editStats: 'Uredi statistiku',
      noSportSelected: 'Odaberi sport',
      noSportSelectedDesc: 'Odaberi sport gore da vidiš svoju statistiku',
      noStats: 'Nema statistike',
      noStatsDesc: 'Dodaj svoju prvu utakmicu da počneš pratiti statistiku',
      totalMatches: 'Ukupno utakmica',
      wins: 'Pobjede',
      losses: 'Porazi',
      draws: 'Neriješeno',
      winRate: 'Win Rate',
      goalsScored: 'Golovi',
      assists: 'Asistencije',
      cleanSheets: 'Clean Sheets',
      yellowCards: 'Žuti kartoni',
      redCards: 'Crveni kartoni',
      recentMatches: 'Nedavne utakmice',
      win: 'Pobjeda',
      loss: 'Poraz',
      draw: 'Neriješeno',
      addMatchTitle: 'Dodaj utakmicu',
      dateLabel: 'Datum *',
      opponentLabel: 'Protivnik *',
      opponentPlaceholder: 'npr. Crveni Tigrovi',
      resultLabel: 'Rezultat *',
      scoreLabel: 'Rezultat *',
      scorePlaceholder: 'npr. 3-2',
      goalsLabel: 'Golovi',
      assistsLabel: 'Asistencije',
      positionLabel: 'Pozicija',
      matchAdded: 'Utakmica dodana!',
      matchAddError: 'Greška pri dodavanju utakmice',
      editStatsTitle: 'Uredi statistiku',
      editStatsDesc: 'Ručno unesi ili ažuriraj svoju statistiku',
      statsUpdated: 'Statistika ažurirana!',
      statsUpdateError: 'Greška pri ažuriranju statistike',
      saveChanges: 'Spremi promjene',
      deleteMatchConfirm: 'Jesi li siguran da želiš obrisati ovu utakmicu?',
      matchDeleted: 'Utakmica obrisana',
      matchDeleteError: 'Greška pri brisanju utakmice',
      selectSportFirst: 'Odaberi sport!',
      fillRequired: 'Popuni sva obavezna polja!',
      positions: {
        forward: 'Napadač',
        midfielder: 'Vezni',
        defender: 'Obrambeni',
        goalkeeper: 'Golman',
      },
    },

    // Rating
    rating: {
      title: 'Ocjene',
      selfRating: 'Ocijeni se',
      sportRating: 'Ocijeni se po sportu',
      leaderboard: 'Ljestvica',
      achievements: 'Postignuća',
      level: 'Razina',
      overall: 'Ukupno',
      beginner: 'Početnik',
      intermediate: 'Srednji',
      advanced: 'Napredni',
      expert: 'Expert',
      pro: 'Pro',
      rateYourself: 'Ocijeni svoje vještine',
      selectLevel: 'Odaberi svoju razinu',
      levelDescription: {
        1: 'Početnik - Tek učim ovaj sport',
        2: 'Srednji - Poznajem osnove',
        3: 'Napredni - Imam dobro iskustvo',
        4: 'Expert - Vrlo vješt igrač',
        5: 'Pro - Profesionalna razina',
      },
      savedSuccess: 'Ocjena uspješno spremljena!',
      addSportRating: 'Dodaj ocjenu za novi sport',
      selectSport: 'Odaberi sport...',
      alreadyRated: 'već ocijenjeno',
      updateRating: 'Ažuriraj ocjenu',
      myRatings: 'Moje ocjene po sportovima',
      sportRatingDesc: 'Ocijeni svoje vještine za svaki sport posebno. Ovo pomaže u pronalaženju pravih timova za tebe!',
      overallRating: 'Ukupna ocjena',
      addSportDesc: 'Odaberi sport za koji želiš dodati svoju ocjenu',
      rateFor: 'Ocijeni se za',
      sportRatingSaved: 'Ocjena za sport uspješno spremljena!',
      sportRatingError: 'Greška pri spremanju ocjene',
      loadingRatings: 'Učitavanje ocjena...',
      recalculated: 'Rating preračunat!',
      recalculateError: 'Greška pri preračunavanju ratinga',
      yourRating: 'Tvoja ocjena',
      alreadyRatedDesc: 'Već si se ocijenio. Drugi igrači te sada mogu ocjenjivati na temelju tvojih performansi.',
      rateBeforeOthers: 'Prije nego te drugi mogu ocijeniti, trebaš se sam ocijeniti. Budi iskren - to pomaže u stvaranju uravnoteženih timova!',
      whatLevel: 'Koja je tvoja razina vještine?',
      amateur: 'Amater',
      amateurDesc: 'Tek počinjem, učim osnove sporta',
      beginnerDesc: 'Znam osnove, igram rekreativno',
      intermediateDesc: 'Solidno igram, imam iskustva',
      advancedDesc: 'Igram u klubu ili na višoj razini',
      proDesc: 'Profesionalni ili poluprofesionalni igrač',
      saveRating: 'Spremi ocjenu',
      myAchievements: 'Moji Achievements',
      achievementsDesc: 'Otkljućaj achievements igranjem utakmica i postizanjem ciljeva',
      noAchievements: 'Još nemaš achievements. Igraj utakmice da ih otkljućaš!',
      unlocked: 'Otkljućano!',
      teamRequiresLevel: 'Ovaj tim zahtijeva minimalnu razinu vještine: {level}',
      teamMaxLevel: 'Ovaj tim zahtijeva maksimalnu razinu vještine: {level}',
      noPlayersFiltered: 'Nema igrača s ovim filterima',
    },

    // Fields
    fields: {
      title: 'Mapa Terena',
      subtitle: 'Pronađi savršeni teren za svoju utakmicu',
      addField: 'Dodaj novi teren',
      fieldName: 'Naziv terena',
      address: 'Adresa',
      city: 'Grad',
      country: 'Država',
      price: 'Cijena',
      pricePerHour: 'EUR/h',
      availability: 'Dostupnost',
      available: 'Dostupno',
      unavailable: 'Zauzeto',
      facilities: 'Sadržaji',
      images: 'Slike',
      openInMaps: 'Otvori u kartama',
      getDirections: 'Upute za dolazak',
      basicInfo: 'Osnovne informacije',
      locationInfo: 'Lokacija',
      imagesAndFacilities: 'Slike i sadržaji',
      review: 'Pregled',
      workingHours: 'Radno vrijeme',
      contact: 'Kontakt',
      phone: 'Telefon',
      website: 'Web stranica',
      noFields: 'Nema terena',
      fieldsFound: 'terena pronađeno',
      selectField: 'Odaberi teren',
      clickToViewDetails: 'Klikni na teren s liste za prikaz detalja',
      filterFields: 'Filtriraj terene',
      priceOnRequest: 'Cijena na upit',
      notSpecified: 'Nije navedeno',
    },

    // Tournaments
    tournaments: {
      title: 'Turniri',
      createTournament: 'Kreiraj turnir',
      register: 'Prijavi se',
      teamName: 'Naziv tima',
      players: 'Igrači',
      format: 'Format',
      knockout: 'Nokaut',
      league: 'Liga',
      entryFee: 'Kotizacija',
      prize: 'Nagrada',
      status: 'Status',
      upcoming: 'Nadolazeći',
      active: 'Aktivan',
      finished: 'Završen',
      registeredTeams: 'Prijavljeni timovi',
      bracket: 'Raspored',
      noTournaments: 'Nema turnira',
      loadError: 'Greška pri učitavanju turnira',
      createSuccess: 'Turnir uspješno kreiran! 🏆',
      createError: 'Greška pri kreiranju turnira',
      fillRequired: 'Molimo popunite sva obavezna polja!',
      endBeforeStart: 'Datum završetka ne može biti prije datuma početka!',
      maxPlayersError: 'Maksimalan broj natjecatelja mora biti veći ili jednak minimumu!',
      registerTeam: 'Prijavi tim',
      registerTeamOn: 'Prijavi tim na',
      enterTeamName: 'Molimo unesite naziv tima!',
      minPlayersError: 'Potrebno je minimalno {n} natjecatelja!',
      registerSuccess: 'Tim uspješno prijavljen! 🎉',
      registerError: 'Greška pri prijavi tima',
      noRegisteredTeams: 'Nema prijavljenih timova.',
      waitlistTag: 'Lista čekanja',
      registeredAt: 'Prijavljeno:',
      tournamentCategory: 'Kategorija turnira *',
      mixedTournament: 'Mješoviti turnir',
      maleTournament: 'Muški turnir',
      femaleTournament: 'Ženski turnir',
      categoryDesc: 'Tip turnira - muški, ženski ili mješoviti',
      playerFilters: 'Filteri za igrače/timove',
      extraPlayerFee: 'Naknada za dodatnog igrača (€)',
      extraPlayerFeeDesc: 'Naknada za svakog igrača iznad minimuma',
      prizePlaceholder: 'npr. 1,000 € + trofej',
      descriptionPlaceholder: 'Dodaj dodatne informacije o turniru...',
      genderMale: 'Muški',
      genderFemale: 'Ženski',
      genderMix: 'Mješoviti',
      competitor: 'Natjecatelj',
      substitute: 'Zamjena',
      subtitle: 'Natjecanja, pobjednici, slava!',
      tabInfo: 'Informacije',
tabTeams: 'Timovi',
tabBracket: 'Raspored',
tabMatches: 'Utakmice',
aboutTournament: 'O turniru',
maxTeams: 'Broj timova',
playersPerTeam: 'Igrača po timu',
free: 'Besplatno',
organizer: 'Organizator',
yourTeamRegistered: 'Tvoj tim je prijavljen!',
unregister: 'Odjavi tim',
spotsAvailable: 'Još uvijek ima mjesta! Prijavi svoj tim i sudjeluj u turniru.',
registerTeam: 'Prijavi tim',
tournamentFull: 'Turnir je popunjen!',
teamsReady: 'Timovi prijavljeni. Generiraj bracket!',
generateBracket: 'Generiraj Bracket',
notEnoughTeams: 'Bracket će biti generiran kada se prijavi dovoljno timova (min 2)',
bracketNotGenerated: 'Bracket još nije generiran',
matchesWhenStarted: 'Utakmice će biti prikazane ovdje kada turnir počne',
    },

    // Profile
    profile: {
      title: 'Profil',
      editProfile: 'Uredi profil',
      firstName: 'Ime',
      lastName: 'Prezime',
      dateOfBirth: 'Datum rođenja',
      gender: 'Spol',
      male: 'Muško',
      female: 'Žensko',
      other: 'Ostalo',
      bio: 'Biografija',
      favoriteSports: 'Omiljeni sportovi',
      stats: 'Statistika',
      totalMatches: 'Ukupno utakmica',
      wins: 'Pobjede',
      goals: 'Golovi',
    },

    // Activities
    activities: {
      title: 'Aktivnosti',
      subtitle: 'Vidi što se događa u TeamConnects zajednici',
      noActivities: 'Nema aktivnosti',
      noActivitiesDesc: 'Kada ti ili tvoji prijatelji nešto napravite, vidjet ćeš to ovdje!',
      loadMore: 'Učitaj više',
      teamCreated: 'je kreirao tim',
      teamJoined: 'se pridružio timu',
      matchPlayed: 'je odigrao utakmicu protiv',
      matchWon: 'je pobijedio',
      videoUploaded: 'je uploadao video',
      tournamentCreated: 'je kreirao turnir',
      tournamentJoined: 'se prijavio na turnir',
      fieldAdded: 'je dodao teren',
      friendAdded: 'su sada prijatelji',
      achievementUnlocked: 'je otključao achievement',
      rankUp: 'je napredovao iz',
      goalScored: 'je postigao gol',
      didSomething: 'je napravio nešto',
      justNow: 'Upravo sada',
      minutesAgo: 'Prije {n} min',
      hoursAgo: 'Prije {n}h',
      daysAgo: 'Prije {n} dana',
      allActivities: 'Sve aktivnosti',
      teamsFilter: 'Timovi',
      matchesFilter: 'Utakmice',
      videosFilter: 'Videi',
      tournamentsFilter: 'Turniri',
      loadError: 'Greška pri učitavanju aktivnosti',
      withTeam: 's timom',
      scoreResult: 'rezultatom',
    },

    // Messages
    messages: {
      loginRequired: 'Molimo prijavite se',
      unauthorized: 'Nemate pristup',
      serverError: 'Greška servera',
      networkError: 'Greška mreže',
      saveSuccess: 'Uspješno spremljeno',
      deleteSuccess: 'Uspješno obrisano',
      updateSuccess: 'Uspješno ažurirano',
      confirmDelete: 'Jeste li sigurni da želite obrisati?',
    },

    // Errors
    errors: {
      teamNotFound: 'Tim nije pronađen',
      teamFull: 'Tim je popunjen',
      alreadyInTeam: 'Već ste član ovog tima',
      notTeamCreator: 'Samo kreator tima može izvršiti ovu akciju',
      genderMaleOnly: 'Ovaj tim je samo za muške igrače',
      genderFemaleOnly: 'Ovaj tim je samo za ženske igračice',
      skillTooLow: 'Vaša razina vještine je preniska za ovaj tim',
      skillTooHigh: 'Vaša razina vještine je previsoka za ovaj tim',
      amateurOnly: 'Ovaj tim je samo za amatere',
      needSelfRating: 'Morate se ocijeniti prije pridruživanja',
      failedToJoin: 'Pridruživanje timu nije uspjelo',
      failedToLeave: 'Napuštanje tima nije uspjelo',
      failedToDelete: 'Brisanje tima nije uspjelo',
      invalidCredentials: 'Nevažeći email ili lozinka',
      emailExists: 'Email već postoji',
      usernameExists: 'Korisničko ime već postoji',
      fieldRequired: 'Ovo polje je obavezno',
      invalidEmail: 'Nevažeći email format',
      passwordTooShort: 'Lozinka mora imati najmanje 6 znakova',
      passwordMismatch: 'Lozinke se ne podudaraju',
      uploadFailed: 'Upload nije uspio',
      maxImages: 'Maksimalno {n} slika',
      imageTooLarge: 'Slika je prevelika (max {n}MB)',
    },

    // Facilities
    facilityNames: {
      parking: 'Parking',
      shower: 'Tuš',
      locker: 'Svlačionice',
      lighting: 'Rasvjeta',
      wifi: 'WiFi',
      ac: 'Klima',
      cafe: 'Kafić',
      restaurant: 'Restoran',
      stands: 'Tribine',
      sound: 'Ozvučenje',
      equipment: 'Oprema za najam',
      firstaid: 'Prva pomoć',
    },
  },

  en: {
    // Common
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      search: 'Search',
      filter: 'Filter',
      reset: 'Reset',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      info: 'Info',
      all: 'All',
      none: 'None',
      select: 'Select',
      required: 'Required',
      optional: 'Optional',
      support: 'Support',
      send: 'Send',
      confirm: 'Confirm',
      checking: 'Checking...',
      saving: 'Saving...',
      searching: 'Searching...',
      unknown: 'Unknown',
      sortBy: 'Sort by',
    },

    // Navigation
    nav: {
      home: 'Home',
      dashboard: 'Dashboard',
      teams: 'Teams',
      myTeams: 'My Teams',
      createTeam: 'Create Team',
      tournaments: 'Tournaments',
      fields: 'Fields',
      activities: 'Activities',
      friends: 'Friends',
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Logout',
      login: 'Login',
      register: 'Register',
      ratings: 'Ratings',
      statistics: 'Statistics',
      highlights: 'Highlights',
      admin: 'Admin',
      notifications: 'Notifications',
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode',
      switchToLight: 'Switch to light mode',
      switchToDark: 'Switch to dark mode',
      messages: 'Messages',
      groups: 'Groups',
      myStudio: 'My Studio',
    },
    groups: {
  title: 'Groups',
  subtitle: 'Join a group or create your own',
  createGroup: 'Create Group',
  joinByCode: '🔑 Join by Code',
  noGroups: 'No Groups',
  noGroupsDesc: 'Create a new group or join an existing one with a code',
  creator: '👑 Organizer',
  member: '🏃 Member',
  youAreCreator: '👑 You are the organizer',
  youAreMember: '🏃 You are a member',
  sessions: 'Sessions',
  members: 'Members',
  newSession: '+ New Session',
  inviteCode: '🔑 Invite Code',
  leaveGroup: 'Leave Group',
  noSessions: 'No sessions',
  noSessionsDesc: 'Create the first session!',
  noMembers: 'No members',
  noMembersDesc: 'Share the invite code for others to join',
  inviteCodeTitle: '🔑 Group Invite Code',
  inviteCodeDesc: 'Share this code for others to join the group:',
  copyCode: '📋 Copy Code',
  codeCopied: '✅ Code copied!',
  joinGroup: '🔑 Join Group',
  inviteCodeLabel: 'Invite Code',
  inviteCodePlaceholder: 'Enter group code...',
  joinSuccess: '✅ You joined the group!',
  invalidCode: 'Invalid group code',
  createGroupTitle: '🏃 Create Group',
  nameLabel: 'Name *',
  namePlaceholder: 'e.g. Volleyball Club Split',
  sportLabel: 'Sport *',
  descLabel: 'Description',
  minSkill: 'Min. level (1-10)',
  maxSkill: 'Max. level (1-10)',
  minPlayers: 'Min. players',
  maxPlayers: 'Max. players',
  isPublic: '🌍 Make Public',
  makePrivate: '🔒 Make Private',
  publicBadge: '🌍 Public',
  belowMin: '⚠️ Not enough signups',
  signedUp: '✅ Signed Up',
  publicSessions: '🌍 Public Group Sessions',
  publicSessionsDesc: 'These sessions are open to everyone — join in!',
  signupSuccess: '✅ You signed up for the session!',
  removeCreator: 'Creator cannot leave the group',
  leaveSuccess: 'You left the group',
  groupCreated: '✅ Group created!',
  sessionCreated: '✅ Session created!',
  memberRemoved: 'Member removed',
  sessionDeleted: 'Session deleted',
  visibilityChanged: 'Session visibility changed',
},
dm: {
  title: 'Messages',
  noConversations: 'No conversations',
  selectConversation: 'Select a conversation',
},
    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      username: 'Username',
      forgotPassword: 'Forgot password?',
      rememberMe: 'Remember me',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      loginSuccess: 'Login successful!',
      registerSuccess: 'Registration successful! Welcome!',
      logoutConfirm: 'Are you sure you want to logout?',
      logoutSuccess: 'Logout successful!',
      welcomeBack: 'Welcome back!',
      createAccount: 'Create Account',
      yourEmail: 'Your email',
      yourPassword: 'Your password',
      loggingIn: 'Logging in...',
      loginBtn: 'Log in',
      registerBtn: 'Register',
      registering: 'Registering...',
      chooseUsername: 'Choose your username',
      minChars: 'Minimum {n} characters',
      welcomeTitle: 'Welcome to TeamConnects!',
      welcomeDesc: 'TeamConnects connects athletes and recreational players by location and sport. Find teammates, join teams, or organize your own sporting events.',
      step1: '1. Register',
      step2: '2. Choose sport',
      step3: '3. Find team',
      gender: 'Gender',
      selectGender: '-- Select gender --',
      male: 'Male',
      female: 'Female',
      securityQuestion: 'Security Question',
      selectSecurityQuestion: '-- Select security question --',
      securityAnswer: 'Security Question Answer',
      yourAnswer: 'Your answer...',
      passwordMismatch: 'Passwords do not match!',
      passwordTooShort: 'Password must be at least 6 characters!',
      reenterPassword: 'Re-enter password',
      loginError: 'Login error',
      registerError: 'Registration error',
      securityQuestions: {
        pet: "What is your first pet's name?",
        city: 'What city were you born in?',
        school: 'What was your elementary school called?',
        team: 'What is your favorite sports team?',
        food: 'What is your favorite food?',
      },
    },

    // Forgot Password
    forgotPw: {
      title: 'Forgot Password',
      enterCode: 'Enter Code',
      newPassword: 'New Password',
      securityQuestion: 'Security Question',
      answerQuestion: 'Answer the Question',
      emailDesc: 'Enter your account email address and we will send you a reset code.',
      codeDesc: 'Enter the 6-digit code sent to',
      newPasswordDesc: 'Enter a new password for your account.',
      securityEmailDesc: 'Enter your account email address to get your security question.',
      securityAnswerDesc: 'Answer the security question for account',
      codeSent: 'Code sent to your email!',
      codeMustBe6: 'Code must be 6 digits!',
      codeValid: 'Code is valid!',
      passwordChanged: 'Password changed successfully!',
      answerCorrect: 'Answer is correct!',
      sendCode: 'Send Code',
      sending: 'Sending...',
      verifyCode: 'Verify Code',
      verifying: 'Verifying...',
      sendNewCode: 'Send New Code',
      saveNewPassword: 'Save New Password',
      fetchQuestion: 'Get Question',
      fetching: 'Fetching...',
      confirmAnswer: 'Confirm Answer',
      useSecurityQuestion: 'Or use security question',
      useEmailCode: 'Or use email code',
      backToLogin: 'Back to login',
      needHelp: 'Need help? Contact us:',
      userNotFound: 'User not found or has no security question',
      invalidCode: 'Invalid code',
      sendError: 'Error sending code',
      resetError: 'Error changing password',
      invalidAnswer: 'Invalid answer',
    },

    // Landing Page
    landing: {
      badge: '🏀 Sports Platform ',
      heroTitle1: 'Find your team.',
      heroTitle2: 'Play. Win.',
      heroDesc: 'TeamConnects connects athletes and recreational players by location and sport. Find teammates, join teams, or organize your own sporting events.',
      startFree: 'Start for free',
      haveAccount: 'Already have an account',
      teams: 'Teams',
      tournaments: 'Tournaments',
      fields: 'Fields',
      featuresTitle: 'Everything you need in one place',
      featuresSubtitle: 'TeamConnects helps you find players, organize matches, and track your progress.',
      featureFindPlayers: 'Find Teammates',
      featureFindPlayersDesc: 'Connect with players in your city who share your passion for sport.',
      featureTournaments: 'Tournaments',
      featureTournamentsDesc: 'Create or register for tournaments. Compete and win prizes!',
      featureFields: 'Sports Fields',
      featureFieldsDesc: 'Find the perfect field for your match with detailed information.',
      featureStats: 'Statistics',
      featureStatsDesc: 'Track your stats, ratings, and progress over time.',
      featureChat: 'Team Chat',
      featureChatDesc: 'Communicate with your team in real-time and organize matches.',
      featureVideo: 'Video Highlights',
      featureVideoDesc: 'Share the best moments from your matches.',
      howItWorks: 'How does it work?',
      step1Title: 'Sign Up',
      step1Desc: 'Create a free account in just a few seconds.',
      step2Title: 'Choose a Sport',
      step2Desc: 'Select your favorite sport and location.',
      step3Title: 'Find a Team',
      step3Desc: 'Join an existing team or create your own!',
      ctaTitle: 'Ready to play?',
      ctaDesc: 'Join the TeamConnects community and find your teammates today!',
      ctaButton: 'Create account for free',
      copyright: '© 2026 TeamConnects. All rights reserved.',
      support: 'Support',
    },

    // Dashboard
    dashboard: {
      availableTeams: 'Available Teams',
      findTeam: 'Find a team and join a match!',
      createNewTeam: '+ Create New Team',
      filterTeams: 'Filter Teams',
      allSports: 'All Sports',
      allCountries: 'All Countries',
      allCities: 'All Cities',
      resetFilters: 'Reset Filters',
      noTeams: 'No Teams',
      noTeamsFiltered: 'No teams match your filters. Try changing the criteria.',
      noTeamsEmpty: 'No teams available yet. Be the first to create one!',
      loadError: 'Error loading teams',
      joinSuccess: 'Successfully joined the team! 🎉',
      joinError: 'Error joining team',
      teamIdError: 'Error: Team ID not available',
      waitlistError: 'Error adding to waitlist',
      popular: 'Popular',
      other: 'Other',
      today: 'Today',
      tomorrow: 'Tomorrow',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },

    // Create Team
    createTeam: {
      title: 'Create New Team',
      subtitle: 'Organize a match and invite players',
      teamNameLabel: 'Team Name *',
      teamNamePlaceholder: 'e.g. Evening match at Central Park',
      sportLabel: 'Sport *',
      selectSport: 'Select sport',
      popularSports: 'Popular Sports',
      otherSports: 'Other Sports',
      addNewSport: '+ Add New Sport',
      countryLabel: 'Country *',
      cityLabel: 'City *',
      searchCity: 'Search city...',
      addNewCity: '+ Add New City',
      locationLabel: 'Exact Location *',
      locationPlaceholder: 'e.g. Central Park, 5th Avenue',
      dateLabel: 'Date *',
      timeLabel: 'Time *',
      maxPlayersLabel: 'Max Players',
      joinAsPlayer: 'Join as Player',
      joinAsPlayerDesc: 'If checked, you will be registered as a player. Otherwise you will be the organizer only.',
      yourPosition: 'Your Position',
      positionPlaceholder: 'e.g. Forward, Goalkeeper, Center, Playmaker...',
      positionDesc: 'Enter the position you want to play (optional)',
      playerFilters: 'Player Filters',
      playerFiltersDesc: 'Set requirements for who can join the team',
      genderPreference: 'Player Gender',
      genderMix: 'Mixed (all)',
      genderMaleOnly: 'Males only',
      genderFemaleOnly: 'Females only',
      amateurOnly: 'Amateurs only',
      amateurDesc: 'Players with rating below 60%',
      minSkill: 'Min. Skill Level',
      maxSkill: 'Max. Skill Level',
      noLimit: 'No limit',
      descriptionLabel: 'Description (optional)',
      descriptionPlaceholder: 'Add additional info about the match...',
      createBtn: 'Create Team',
      createSuccess: 'Team created successfully! 🎉',
      createError: 'Error creating team',
      fillRequired: 'Please fill all required fields!',
      addSportTitle: 'Add New Sport',
      addSportDesc: "Don't see your sport? Add it!",
      sportNameLabel: 'Sport Name',
      sportNamePlaceholder: 'e.g. Padel, Squash, Paintball...',
      addSportBtn: 'Add Sport',
      enterSportName: 'Enter sport name!',
      sportAdded: 'Sport "{name}" added! 🎉',
      addCityTitle: 'Add New City',
      addCityDesc: "Don't see your city? Add it!",
      cityNameLabel: 'City Name',
      cityNamePlaceholder: 'e.g. Amsterdam, Luxembourg...',
      countryNameLabel: 'Country',
      countryNamePlaceholder: 'e.g. Netherlands',
      addCityBtn: 'Add City',
      fillCityCountry: 'Fill in city and country name!',
      cityAdded: 'City "{name}" added! 🎉',
      skillLevels: {
        1: '1 - Beginner',
        2: '2 - Intermediate',
        3: '3 - Advanced',
        4: '4 - Expert',
        5: '5 - Pro',
      },
    },

    // My Teams
    myTeams: {
      title: 'My Teams',
      subtitle: 'Manage your teams',
      createNew: '+ Create New Team',
      noTeams: 'No Teams',
      noTeamsDesc: 'Create a new team or browse available teams on the Dashboard',
      browseTeams: 'Browse Teams',
      loadError: 'Error loading teams',
      leaveConfirm: 'Are you sure you want to leave this team?',
      leftTeam: 'You have left the team',
      leaveError: 'Error leaving team',
      deleteConfirm: 'Are you sure you want to delete this team? This action cannot be undone!',
      deleted: 'Team deleted',
      deleteError: 'Error deleting team',
    },

    // Teams
    teams: {
      title: 'Teams',
      availableTeams: 'Available Teams',
      myTeams: 'My Teams',
      createTeam: 'Create Team',
      joinTeam: 'Join',
      leaveTeam: 'Leave Team',
      deleteTeam: 'Delete Team',
      teamName: 'Team Name',
      sport: 'Sport',
      location: 'Location',
      date: 'Date',
      time: 'Time',
      maxPlayers: 'Max Players',
      currentPlayers: 'Current Players',
      description: 'Description',
      creator: 'Creator',
      players: 'Players',
      full: 'FULL',
      waitlist: 'Waitlist',
      joinWaitlist: 'Join Waitlist',
      position: 'Position',
      skillLevel: 'Skill Level',
      amateur: 'Amateur',
      createdTeams: 'Teams I Created',
      joinedTeams: 'Teams I Joined',
      noTeams: 'No Teams',
      registeredPlayers: 'Registered Players',
      showPlayers: 'Show',
      hidePlayers: 'Hide',
      noPlayersYet: 'No registered players yet',
      shareToAttract: 'Share team link to attract players!',
      onWaitlist: 'On Waitlist',
      skillRange: 'Level',
      loginToAccess: 'Login to access',
      shareLink: 'Share link',
      linkCopied: 'Copied!',
      joinTeamTitle: 'Join Team',
      joinTeamDesc: 'Enter the position you want to play (optional)',
      positionPlaceholder: 'e.g. Forward, Goalkeeper, Center...',
      yourRating: 'Your rating for',
      ratingError: 'Error saving rating',
      personsWaiting: '{n} on waitlist',
      loginRequired: 'Please login to access this feature!',
      alreadyMember: 'You are a member',
      checking: 'Checking...',
      chat: 'Chat',
    },

    // Chat
    chat: {
      loadingChat: 'Loading chat...',
      teamNotFound: 'Team does not exist',
      playersCount: '{current}/{max} players',
      noMessages: 'No messages',
      beFirst: 'Be the first to write something!',
      isTyping: '{name} is typing...',
      writeMessage: 'Write a message...',
      sendBtn: 'Send',
      shareLocation: 'Share location',
      locationShared: 'Location shared!',
      locationNotSupported: 'Geolocation is not supported',
      locationError: 'Unable to get location',
      viewOnMap: 'View location on map',
      deleteMessage: 'Delete message?',
      today: 'Today',
      yesterday: 'Yesterday',
      back: 'Back',
    },

    // Notifications
    notifications: {
      title: 'Notifications',
      markAll: 'Mark All',
      deleteAll: 'Delete All',
      filterAll: 'All',
      filterUnread: 'Unread',
      noNotifications: 'No notifications',
      noNotificationsDesc: 'When something happens, you will see it here',
      newBadge: 'NEW',
      allMarkedRead: 'All notifications marked as read',
      allDeleted: 'All notifications deleted',
      deleteConfirm: 'Are you sure you want to delete all notifications?',
      loadError: 'Error loading notifications',
      markError: 'Error marking notifications',
      deleteError: 'Error deleting notifications',
    },

    // Friends
    friends: {
      title: 'Friends',
      subtitle: 'Connect with players',
      searchUsers: 'Search Users',
      searchPlaceholder: 'Search by username or email...',
      searchBtn: 'Search',
      searchMinChars: 'Enter at least 2 characters!',
      friendsTab: 'Friends',
      requestsTab: 'Requests',
      resultsTab: 'Results',
      noFriends: 'No friends yet',
      noFriendsDesc: 'Search for users and add them as friends!',
      noRequests: 'No new requests',
      noRequestsDesc: 'When someone adds you, you will see it here',
      noResults: 'No results',
      noResultsDesc: 'Try a different search term',
      viewProfile: 'View Profile',
      removeFriend: 'Remove',
      removeFriendConfirm: 'Are you sure you want to remove this friend?',
      friendRemoved: 'Friend removed',
      removeError: 'Error removing friend',
      accept: 'Accept',
      reject: 'Reject',
      requestSent: 'Request sent!',
      sendError: 'Error sending request',
      acceptError: 'Error accepting request',
      rejectError: 'Error rejecting request',
      rejected: 'Request rejected',
      alreadyFriends: 'Already friends',
      requestAlreadySent: 'Request sent',
      itsYou: "That's you",
      addFriend: '+ Add Friend',
      addFriendTitle: 'Add Friend',
      sendRequestTo: 'Send request to',
      messageOptional: 'Message (optional)',
      messagePlaceholder: 'Write a short message...',
      sendRequest: 'Send Request',
      searchError: 'Error searching',
    },

    // Statistics
    statistics: {
      title: 'My Statistics',
      subtitle: 'Track your progress and performance',
      selectSport: 'Select Sport',
      selectSportDefault: '-- Select sport --',
      addMatch: '+ Add Match',
      editStats: 'Edit Statistics',
      noSportSelected: 'Select a sport',
      noSportSelectedDesc: 'Select a sport above to see your statistics',
      noStats: 'No statistics',
      noStatsDesc: 'Add your first match to start tracking stats',
      totalMatches: 'Total Matches',
      wins: 'Wins',
      losses: 'Losses',
      draws: 'Draws',
      winRate: 'Win Rate',
      goalsScored: 'Goals',
      assists: 'Assists',
      cleanSheets: 'Clean Sheets',
      yellowCards: 'Yellow Cards',
      redCards: 'Red Cards',
      recentMatches: 'Recent Matches',
      win: 'Win',
      loss: 'Loss',
      draw: 'Draw',
      addMatchTitle: 'Add Match',
      dateLabel: 'Date *',
      opponentLabel: 'Opponent *',
      opponentPlaceholder: 'e.g. Red Tigers',
      resultLabel: 'Result *',
      scoreLabel: 'Score *',
      scorePlaceholder: 'e.g. 3-2',
      goalsLabel: 'Goals',
      assistsLabel: 'Assists',
      positionLabel: 'Position',
      matchAdded: 'Match added!',
      matchAddError: 'Error adding match',
      editStatsTitle: 'Edit Statistics',
      editStatsDesc: 'Manually enter or update your statistics',
      statsUpdated: 'Statistics updated!',
      statsUpdateError: 'Error updating statistics',
      saveChanges: 'Save Changes',
      deleteMatchConfirm: 'Are you sure you want to delete this match?',
      matchDeleted: 'Match deleted',
      matchDeleteError: 'Error deleting match',
      selectSportFirst: 'Select a sport!',
      fillRequired: 'Fill all required fields!',
      positions: {
        forward: 'Forward',
        midfielder: 'Midfielder',
        defender: 'Defender',
        goalkeeper: 'Goalkeeper',
      },
    },

    // Rating
    rating: {
      title: 'Ratings',
      selfRating: 'Rate Yourself',
      sportRating: 'Rate by Sport',
      leaderboard: 'Leaderboard',
      achievements: 'Achievements',
      level: 'Level',
      overall: 'Overall',
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
      expert: 'Expert',
      pro: 'Pro',
      rateYourself: 'Rate Your Skills',
      selectLevel: 'Select your level',
      levelDescription: {
        1: 'Beginner - Just learning this sport',
        2: 'Intermediate - Know the basics',
        3: 'Advanced - Have good experience',
        4: 'Expert - Very skilled player',
        5: 'Pro - Professional level',
      },
      savedSuccess: 'Rating saved successfully!',
      addSportRating: 'Add rating for new sport',
      selectSport: 'Select sport...',
      alreadyRated: 'already rated',
      updateRating: 'Update Rating',
      myRatings: 'My Sport Ratings',
      sportRatingDesc: 'Rate your skills for each sport separately. This helps find the right teams for you!',
      overallRating: 'Overall Rating',
      addSportDesc: 'Select a sport to add your rating',
      rateFor: 'Rate yourself for',
      sportRatingSaved: 'Sport rating saved successfully!',
      sportRatingError: 'Error saving rating',
      loadingRatings: 'Loading ratings...',
      recalculated: 'Rating recalculated!',
      recalculateError: 'Error recalculating rating',
      yourRating: 'Your Rating',
      alreadyRatedDesc: 'You have already rated yourself. Other players can now rate you based on your performance.',
      rateBeforeOthers: 'Before others can rate you, you need to rate yourself. Be honest - it helps create balanced teams!',
      whatLevel: 'What is your skill level?',
      amateur: 'Amateur',
      amateurDesc: 'Just starting, learning the basics',
      beginnerDesc: 'Know the basics, play recreationally',
      intermediateDesc: 'Play well, have experience',
      advancedDesc: 'Play in a club or at a higher level',
      proDesc: 'Professional or semi-professional player',
      saveRating: 'Save Rating',
      myAchievements: 'My Achievements',
      achievementsDesc: 'Unlock achievements by playing matches and reaching goals',
      noAchievements: "No achievements yet. Play matches to unlock them!",
      unlocked: 'Unlocked!',
      teamRequiresLevel: 'This team requires a minimum skill level of {level}',
      teamMaxLevel: 'This team requires a maximum skill level of {level}',
      noPlayersFiltered: 'No players match these filters',
    },

    // Fields
    fields: {
      title: 'Field Map',
      subtitle: 'Find the perfect field for your match',
      addField: 'Add New Field',
      fieldName: 'Field Name',
      address: 'Address',
      city: 'City',
      country: 'Country',
      price: 'Price',
      pricePerHour: 'EUR/h',
      availability: 'Availability',
      available: 'Available',
      unavailable: 'Unavailable',
      facilities: 'Facilities',
      images: 'Images',
      openInMaps: 'Open in Maps',
      getDirections: 'Get Directions',
      basicInfo: 'Basic Information',
      locationInfo: 'Location',
      imagesAndFacilities: 'Images & Facilities',
      review: 'Review',
      workingHours: 'Working Hours',
      contact: 'Contact',
      phone: 'Phone',
      website: 'Website',
      noFields: 'No Fields',
      fieldsFound: 'fields found',
      selectField: 'Select Field',
      clickToViewDetails: 'Click on a field from the list to view details',
      filterFields: 'Filter fields',
      priceOnRequest: 'Price on request',
      notSpecified: 'Not specified',
    },

    // Tournaments
    tournaments: {
      title: 'Tournaments',
      createTournament: 'Create Tournament',
      register: 'Register',
      teamName: 'Team Name',
      players: 'Players',
      format: 'Format',
      knockout: 'Knockout',
      league: 'League',
      entryFee: 'Entry Fee',
      prize: 'Prize',
      status: 'Status',
      upcoming: 'Upcoming',
      active: 'Active',
      finished: 'Finished',
      registeredTeams: 'Registered Teams',
      bracket: 'Bracket',
      noTournaments: 'No Tournaments',
      loadError: 'Error loading tournaments',
      createSuccess: 'Tournament created successfully! 🏆',
      createError: 'Error creating tournament',
      fillRequired: 'Please fill all required fields!',
      endBeforeStart: 'End date cannot be before start date!',
      maxPlayersError: 'Max players must be greater than or equal to minimum!',
      registerTeam: 'Register Team',
      registerTeamOn: 'Register team for',
      enterTeamName: 'Please enter a team name!',
      minPlayersError: 'Minimum {n} players required!',
      registerSuccess: 'Team registered successfully! 🎉',
      registerError: 'Error registering team',
      noRegisteredTeams: 'No registered teams.',
      waitlistTag: 'Waitlist',
      registeredAt: 'Registered:',
      tournamentCategory: 'Tournament Category *',
      mixedTournament: 'Mixed Tournament',
      maleTournament: 'Male Tournament',
      femaleTournament: 'Female Tournament',
      categoryDesc: 'Tournament type - male, female, or mixed',
      playerFilters: 'Player/Team Filters',
      extraPlayerFee: 'Extra Player Fee (€)',
      extraPlayerFeeDesc: 'Fee for each player above the minimum',
      prizePlaceholder: 'e.g. €1,000 + trophy',
      descriptionPlaceholder: 'Add additional info about the tournament...',
      genderMale: 'Male',
      genderFemale: 'Female',
      genderMix: 'Mixed',
      competitor: 'Competitor',
      substitute: 'Substitute',
      subtitle: 'Competitions, champions, glory!',
      tabInfo: 'Information',
tabTeams: 'Teams',
tabBracket: 'Bracket',
tabMatches: 'Matches',
aboutTournament: 'About Tournament',
maxTeams: 'Number of teams',
playersPerTeam: 'Players per team',
free: 'Free',
organizer: 'Organizer',
yourTeamRegistered: 'Your team is registered!',
unregister: 'Unregister team',
spotsAvailable: 'Spots still available! Register your team.',
registerTeam: 'Register Team',
tournamentFull: 'Tournament is full!',
teamsReady: 'Teams registered. Generate bracket!',
generateBracket: 'Generate Bracket',
notEnoughTeams: 'Bracket will be generated when enough teams register (min 2)',
bracketNotGenerated: 'Bracket not yet generated',
matchesWhenStarted: 'Matches will be shown here when the tournament starts',
    },

    // Profile
    profile: {
      title: 'Profile',
      editProfile: 'Edit Profile',
      firstName: 'First Name',
      lastName: 'Last Name',
      dateOfBirth: 'Date of Birth',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      bio: 'Bio',
      favoriteSports: 'Favorite Sports',
      stats: 'Statistics',
      totalMatches: 'Total Matches',
      wins: 'Wins',
      goals: 'Goals',
    },

    // Activities
    activities: {
      title: 'Activities',
      subtitle: "See what's happening in the TeamConnect community",
      noActivities: 'No activities',
      noActivitiesDesc: 'When you or your friends do something, you will see it here!',
      loadMore: 'Load More',
      teamCreated: 'created a team',
      teamJoined: 'joined team',
      matchPlayed: 'played a match against',
      matchWon: 'won against',
      videoUploaded: 'uploaded a video',
      tournamentCreated: 'created a tournament',
      tournamentJoined: 'registered for tournament',
      fieldAdded: 'added a field',
      friendAdded: 'are now friends',
      achievementUnlocked: 'unlocked achievement',
      rankUp: 'ranked up from',
      goalScored: 'scored a goal',
      didSomething: 'did something',
      justNow: 'Just now',
      minutesAgo: '{n} min ago',
      hoursAgo: '{n}h ago',
      daysAgo: '{n} days ago',
      allActivities: 'All Activities',
      teamsFilter: 'Teams',
      matchesFilter: 'Matches',
      videosFilter: 'Videos',
      tournamentsFilter: 'Tournaments',
      loadError: 'Error loading activities',
      withTeam: 'with team',
      scoreResult: 'with score',
    },

    // Messages
    messages: {
      loginRequired: 'Please login',
      unauthorized: 'Unauthorized',
      serverError: 'Server error',
      networkError: 'Network error',
      saveSuccess: 'Saved successfully',
      deleteSuccess: 'Deleted successfully',
      updateSuccess: 'Updated successfully',
      confirmDelete: 'Are you sure you want to delete?',
    },

    // Errors
    errors: {
      teamNotFound: 'Team not found',
      teamFull: 'Team is full',
      alreadyInTeam: 'You are already a member of this team',
      notTeamCreator: 'Only team creator can perform this action',
      genderMaleOnly: 'This team is for male players only',
      genderFemaleOnly: 'This team is for female players only',
      skillTooLow: 'Your skill level is too low for this team',
      skillTooHigh: 'Your skill level is too high for this team',
      amateurOnly: 'This team is for amateurs only',
      needSelfRating: 'You need to rate yourself before joining',
      failedToJoin: 'Failed to join team',
      failedToLeave: 'Failed to leave team',
      failedToDelete: 'Failed to delete team',
      invalidCredentials: 'Invalid email or password',
      emailExists: 'Email already exists',
      usernameExists: 'Username already exists',
      fieldRequired: 'This field is required',
      invalidEmail: 'Invalid email format',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordMismatch: 'Passwords do not match',
      uploadFailed: 'Upload failed',
      maxImages: 'Maximum {n} images',
      imageTooLarge: 'Image is too large (max {n}MB)',
    },

    // Facilities
    facilityNames: {
      parking: 'Parking',
      shower: 'Shower',
      locker: 'Locker Room',
      lighting: 'Lighting',
      wifi: 'WiFi',
      ac: 'Air Conditioning',
      cafe: 'Café',
      restaurant: 'Restaurant',
      stands: 'Stands',
      sound: 'Sound System',
      equipment: 'Equipment Rental',
      firstaid: 'First Aid',
    },
  },
};

export default translations;
